export { ProviderDaBarraSuperior } from './barra-superior.provider'
